/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_NameInputs */

const en_your_name = /** @type {(inputs: Your_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your name *`)
};

const es_your_name = /** @type {(inputs: Your_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu nombre *`)
};

const fr_your_name = /** @type {(inputs: Your_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre nom *`)
};

const de_your_name = /** @type {(inputs: Your_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Name *`)
};

const ja_your_name = /** @type {(inputs: Your_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お名前 *`)
};

const zh_your_name = /** @type {(inputs: Your_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的姓名 *`)
};

const ar_your_name = /** @type {(inputs: Your_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسمك *`)
};

const id_your_name = /** @type {(inputs: Your_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama Anda *`)
};

const it_your_name = /** @type {(inputs: Your_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo nome *`)
};

const ru_your_name = /** @type {(inputs: Your_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваше имя *`)
};

const pt_your_name = /** @type {(inputs: Your_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu nome *`)
};

const ko_your_name = /** @type {(inputs: Your_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이름 *`)
};

/**
* | output |
* | --- |
* | "Your name *" |
*
* @param {Your_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const your_name = /** @type {((inputs?: Your_NameInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_NameInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_your_name(inputs)
	if (locale === "es") return es_your_name(inputs)
	if (locale === "fr") return fr_your_name(inputs)
	if (locale === "de") return de_your_name(inputs)
	if (locale === "ja") return ja_your_name(inputs)
	if (locale === "zh") return zh_your_name(inputs)
	if (locale === "ar") return ar_your_name(inputs)
	if (locale === "id") return id_your_name(inputs)
	if (locale === "it") return it_your_name(inputs)
	if (locale === "ru") return ru_your_name(inputs)
	if (locale === "pt") return pt_your_name(inputs)
	return ko_your_name(inputs)
});